module.exports = __webpack_public_path__ + "static/simplified-mobile-e64a7bac6be25e993bdd9328991cf052.webp";